import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

export default {
  path: '/advertisements',
  component: Management,
  redirect: '/advertisements/list',
  children: [
    // 列表页
    {
      path: 'list',
      component: () => import('@/views/advertisements/List'),
      redirect: 'list/advertising_space',
      meta: {
        auth: Auth.listAdvertisements
      },
      children: [
        {
          path: 'advertising_space',
          component: () => import('@/views/advertising_spaces/ListTable'),
          meta: {
            auth: Auth.listAdvertisements,
            tabName: 'advertising_space'
          }
        },
        {
          path: 'enabled',
          component: () => import('@/views/advertisements/ListTable'),
          meta: {
            auth: Auth.listAdvertisements,
            tabName: 'enabled'
          }
        },
        {
          path: 'disabled',
          component: () => import('@/views/advertisements/ListTable'),
          meta: {
            auth: Auth.listAdvertisements,
            tabName: 'disabled'
          }
        }
      ]
    },
    // 新增
    {
      path: 'new',
      component: () => import('@/views/advertisements/New'),
      meta: {
        auth: Auth.createAdvertisement
      }
    },
    // 编辑
    {
      path: ':id/edit',
      component: () => import('@/views/advertisements/Edit'),
      meta: {
        auth: Auth.updateAdvertisement
      }
    },
    // 详情
    {
      path: ':id',
      component: () => import('@/views/advertisements/DetailLayout'),
      meta: {
        auth: Auth.showAdvertisement
      },
      children: [
        // 基本信息
        {
          path: 'detail',
          component: () => import('@/views/advertisements/details/Detail'),
          meta: {
            tabName: 'detail', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.showAdvertisement
          }
        },
        // 点击记录
        {
          path: 'click_records',
          component: () => import('@/views/advertisements/details/ClickRecords'),
          meta: {
            tabName: 'click_records', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.showAdvertisement
          }
        }
      ]
    }
  ]
}
